/**
 * Discriminated union of vendor-integration connection states. Replaces the
 * legacy magic-string `connectionStatus` (`'Connect with Rentvine'` /
 * `'Connected with Buildium'` / `'Connection failed.'`) that drove the
 * vendor-page display branches via `isConnected` / `isFailed` / `isNotConnected`
 * derived booleans. `kind` is the source of truth for branching.
 *
 * Display strings used to come from a `connectionStateLabel(state, vendorName)`
 * helper feeding the three-up vendor-logo header. That header is not in the
 * design (PR 3 review, 2026-09-14): connection state is carried by the page
 * header's status label, and a save-time credential failure by the inline
 * `ConnectionFailedAlert`. The helper and the per-state `message` it rendered
 * went with it — nothing reads a message off this union any more.
 */
export type ConnectionState =
  | { kind: 'idle' }
  | { kind: 'connected' }
  | { kind: 'failed' };

export const idleConnection = (): ConnectionState => ({ kind: 'idle' });
export const connectedConnection = (): ConnectionState => ({ kind: 'connected' });
export const failedConnection = (): ConnectionState => ({ kind: 'failed' });
